import { z } from 'zod';
// Запрос на приглашение клиента менеджером.
export const InviteClientRequest = z.object({
    email: z.string().email(),
    fullName: z.string().min(1),
    legalEntityId: z.string().uuid(),
});
// Контакты клиента — все поля опциональны (жёсткую валидацию закладываем на будущее).
// email НЕ входит — у клиента один email (users.email = логин), меняется отдельно.
export const ClientContactsPatch = z.object({
    contactName: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    telegram: z.string().nullable().optional(),
    edoId: z.string().nullable().optional(),
});
// Запрос смены email клиента (= логин). Меняется через подтверждение письмом.
export const ChangeEmailRequest = z.object({
    newEmail: z.string().email(),
});
// Профиль клиента — то, что отдаётся в API. email — единственный (он же логин).
export const ClientProfile = z.object({
    id: z.string(),
    userId: z.string(),
    fullName: z.string(),
    email: z.string(),
    status: z.enum(['invited', 'active', 'blocked']),
    legalEntityId: z.string(),
    legalEntityName: z.string(),
    legalEntityInn: z.string().nullable(),
    contactName: z.string().nullable(),
    phone: z.string().nullable(),
    telegram: z.string().nullable(),
    edoId: z.string().nullable(),
    createdAt: z.string(),
});
//# sourceMappingURL=clients.js.map